import React, { useState } from 'react';
import './Header.css';

export const scrollToSection = (sectionId: string, callback?: Function) => {
  const targetElement = document.querySelector(sectionId);
  if (targetElement) {
    targetElement.scrollIntoView({ behavior: "smooth" });
    if (callback) {
      callback();
    }
  }
};

const Header: React.FC = () => {
  const [isMenuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(!isMenuOpen);
  };

  return (
    <header className="Header">
      <div className="Header-main">
        <div className="Header-logo">
          <img src="LOGONEKSIO1.png" alt="Neksio Land logo" width={180} />
        </div>
        <nav className={`Header-nav ${isMenuOpen ? 'open' : ''}`}>
          {/* Title visible only on small screens and when menu is open */}
          <h2 className="Header-nav-title">Meniu</h2>
          <a  onClick={() => scrollToSection('.map-section', () => setMenuOpen(false))}>Despre noi</a>
          <a  onClick={() => scrollToSection('.our-services', () => setMenuOpen(false))}>Servicii</a>
          <a  onClick={() => scrollToSection('.contact-form-container', () => setMenuOpen(false))}>Contact</a>
          {/* Close button (X) */}
          <button className="Header-close" onClick={toggleMenu}>X</button>
        </nav>
        <div className="Header-burger" onClick={toggleMenu}>
          <div className="burger-icon"></div>
          <div className="burger-icon"></div>
          <div className="burger-icon"></div>
        </div>
      </div>
      {/* Overlay that appears when the menu is open */}
      <div className={`Header-overlay ${isMenuOpen ? 'open' : ''}`} onClick={toggleMenu}></div>
    </header>
  );
};

export default Header;
